<!--
 * @Author: your name
 * @Date: 2023-01-29 12:48:25
 * @LastEditors: your name
 * @LastEditTime: 2023-02-28 16:41:05
 * @FilePath: /developer-black/src/app/routes/project/project-detail/lots/lot-detail-dialog/lot-detail-dialog.component.html
 * @Description: 
 * 
 * Copyright (c) 2023 by 用户/公司名, All Rights Reserved. 
-->
<div fxLayout="row" fxLayoutGap="24px" class="lot_container">
  <div style="padding: 24px;">
    <div class="lot-name fc_DEDEDE">{{lot.lotNumber}}</div>
    <app-property-status [status]="lot.status"></app-property-status>
    <mat-tab-group disableRipple style="margin-top: 15px;">
      <mat-tab label="Details">
        <div fxLayout="column" fxLayoutGap="16px" style="padding-top:16px;width: 320px;">
          <div fxLayout="row" fxLayoutAlign="space-between">
            <div class="lot-attr">Width</div>
            <div class=" lot-value">{{lot.width}} m</div>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-between">
            <div class="lot-attr">Length</div>
            <div class="lot-value">{{lot.length}} m</div>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-between">
            <div class="lot-attr">Total Size</div>
            <div class="lot-value">{{lot.lotSize}} m²</div>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-between">
            <div class="lot-attr">Park Front</div>
            <div class="lot-value">{{lot.parkFront ? 'Yes' : 'No'}}</div>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-between">
            <div class="lot-attr">Lake Front</div>
            <div class="lot-value">{{lot.lakeFront ? 'Yes' : 'No'}}</div>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-between">
            <div class="lot-attr">Corner Block</div>
            <div class="lot-value">{{lot.cornerBlock ? 'Yes' : 'No'}}</div>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-between">
            <div class="lot-attr">Status</div>
            <div class="lot-value">{{getStatusLabel(lot.status)}}</div>
          </div>
          <div fxLayout="row" fxLayoutAlign="end">
            <div class="lot-attr" style="font-size: 14px;align-self: flex-end;margin-right: 16px">{{lot.price /
              lot.lotSize | currency:
              '':'symbol':'1.0-0'}} / m²</div>
            <div class="lot-value" style="font-weight: 700;font-size: 24px;">{{lot.price| currency: '':'symbol':'1.0'}}
            </div>
          </div>
        </div>
      </mat-tab>
      <!-- <mat-tab label="Agency"> Content 2 </mat-tab> -->
    </mat-tab-group>
    <div fxLayout="row" fxLayoutAlign="end" style="margin-top:16px">
      <button mat-flat-button class="edit_button" (click)="editLot()">Edit</button>
    </div>
  </div>

  <div class="lot-packages">
    <div class="package-title fc_DEDEDE">Property Type</div>
    <div fxLayout="column" fxLayoutGap="8px" style="height: 410px;overflow: scroll;">
      <div class="package-box" *ngFor="let property of properties" fxLayout="row">
        <div class="package-image">
          <img *ngIf="property.project && property.project.images && property.project.images.length"
            [src]="SERVER_URL + 'images/' + property.project.projectCode + '/images/' + property.project.images[0].fileName">
        </div>
        <div class="package-detail" fxLayout="column" fxLayoutGap="12px">
          <div class="package-name" fxLayout="row" fxLayoutAlign="space-between">
            <div>{{property.unitNum || property.lotNum}}</div>
            <mat-icon style="cursor:pointer" (click)="editPropertyClick(property)">east</mat-icon>
          </div>

          <div fxLayout="row" fxLayoutGap="20px">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
              <mat-icon>bed</mat-icon>
              <div>{{property.bedRoom || 0}}</div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
              <mat-icon class="material-icons-outlined">shower</mat-icon>
              <div>{{property.bathRoom || 0}}</div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
              <mat-icon class="material-icons-outlined">directions_car</mat-icon>
              <div>{{property.carParking || 0}}</div>
            </div>
          </div>

          <div fxLayout="row" fxLayoutGap="30px">
            <div fxLayout="column" fxLayoutGap="8px">
              <div class="package-attr">building price</div>
              <div class="package-value">{{property.price | currency: '':'symbol':'3.0'}}</div>
            </div>
            <div fxLayout="column" fxLayoutGap="8px">
              <div class="package-attr">total price</div>
              <div class="package-value">{{property.price + lot.price | currency: '':'symbol':'3.0'}}</div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>